export default "__VITE_ASSET__020026f1__"